export const PageTitle = ({ title, subtitle, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-8">
    <div>
      <h1 className="font-display text-2xl md:text-3xl font-bold text-white tracking-tight">
        {title}
      </h1>
      {subtitle && <p className="text-white/45 text-sm mt-1">{subtitle}</p>}
    </div>
    {action}
  </div>
);

export const Card = ({ children, className = "" }) => (
  <div className={`glass-gold p-5 md:p-6 ${className}`}>{children}</div>
);

export const Field = ({ label, children, hint }) => (
  <label className="block">
    <span className="text-xs uppercase tracking-wider text-white/45 font-medium">{label}</span>
    <div className="mt-1.5">{children}</div>
    {hint && <span className="text-[11px] text-white/30 mt-1 block">{hint}</span>}
  </label>
);

export const inputCls =
  "w-full bg-white/[0.03] border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-[#F5C542]/50 transition-colors";

export const GoldButton = ({ children, className = "", ...props }) => (
  <button
    className={`btn-gold font-display font-bold px-5 py-2.5 rounded-xl text-sm hover:scale-[1.02] transition-transform disabled:opacity-60 disabled:hover:scale-100 ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const GhostButton = ({ children, className = "", ...props }) => (
  <button
    className={`px-4 py-2.5 rounded-xl text-sm font-medium bg-white/[0.04] border border-white/10 text-white/80 hover:border-[#F5C542]/40 hover:text-white transition-colors ${className}`}
    {...props}
  >
    {children}
  </button>
);
